import type { MessageKey } from '../i18n/index.ts';

export type ErrorCode =
  | 'slot_taken'
  | 'rate_limited'
  | 'outside_window'
  | 'not_found'
  | 'network'
  | 'invalid'
  | 'unauthorized'
  | 'invalid_login'
  | 'generic';

const MESSAGE: Record<ErrorCode, MessageKey> = {
  slot_taken: 'error.slotTaken',
  rate_limited: 'error.rateLimited',
  outside_window: 'error.outsideWindow',
  not_found: 'error.notFound',
  network: 'error.network',
  invalid: 'error.invalid',
  unauthorized: 'error.unauthorized',
  invalid_login: 'error.invalidLogin',
  generic: 'error.generic',
};

export class AppError extends Error {
  constructor(
    readonly code: ErrorCode,
    message?: string,
  ) {
    super(message ?? code);
    this.name = 'AppError';
  }
}

/** Maps any thrown value to a translatable, human-friendly message key. */
export function errorMessageKey(err: unknown): MessageKey {
  if (err instanceof AppError) return MESSAGE[err.code];
  if (err instanceof TypeError && /fetch|network/i.test(err.message)) return 'error.network';
  return 'error.generic';
}
